import { z } from 'zod';

/** A calendar date, `YYYY-MM-DD`. Dates in the task and project forms are days, not instants. */
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a date like 2026-11-02');

/** Today as `YYYY-MM-DD` in UTC. India is ahead of UTC, so a local "today" is never rejected as past. */
export const todayIso = (now: Date = new Date()) => now.toISOString().slice(0, 10);
